import React, { useEffect, useState, useRef } from "react";
import "./SmartCashPayment.scss";
import ToastMsg from "../../../shared/components/ToastMsg/ToastMsg";
import { useNavigate } from "react-router-dom";
import { useLoading } from "../../../../../Shared/cache/context/LoadingProvider";
import { eventEmitter } from "../../../../../Shared/service/google-analytics.service";
import { intiatePayment, processTrans, checkAMstatus, getOtpV1 } from "../../../shared/service";
import { useLanguage } from "../../../../../Shared/cache/context/LanguageProvider";
import useFetch from "../../../../../Shared/cache/useFetch";
import { TRANSLATION, GET, ORP_TRANSLATION } from "../../../../../Shared/helper/constants";
import { INTIATE_PAYMENT_AM_PIN, PAYMENT_MODE_SMARTCASH, PROCESS_TRXN_AM_PIN } from "../../../helper/constants";
import AwOtpModal from "../../../../odu/components/AwOtpModal";
import PinComponent from "../PinComponent";
import { encryptRSA } from "../../../../../Shared/helper/helper";

export default function SmartCashPayment({selectedCurrencyUnit ,convertedAmount}) {
    const [mobileNumber, setMobileNumber] = useState("");
    const [toastMsg, setToastMsg] = useState(null);
    const [msisdnError, setMsisdnError] = useState("");
    const [txnInfo, setTxnInfo] = useState();
    const { showLoader, hideLoader } = useLoading();
    const [leadInfo, setLeadInfo] = useState({})
    const navigate = useNavigate();
    const { languagePrefix, selectedLanguage } = useLanguage();
    const [showOtpModal, setShowOtpModal] = useState(false);
    const [refId, setRefId] = useState('');
    const [enablePin, setEnablePin] = useState(true)
    const [email, setEmailId] = useState();
    const [token, setToken] = useState('');
    const [showPinModal, setShowPinModal] = useState(false);
    const [showIncorrectPinMessage, setShowIncorrectPinMessage] = useState(false);
    const [showPinLockedMessage, setShowPinLockedMessage] = useState(false);
    const [isAirtelNumber, setIsAirtelNumber] = useState(true);
    const [noOfAttemptsLeftForPIN, setNoOfAttemptsLeftForPIN] = useState(5);
    const [config, setConfig] = useState({});
    const [pin, setPin]=useState();
    const [transactionId, setTransactionId]=useState()
    const [encryptionKey,setEncryptionKey]=useState();

    const [translation, setTranslation] = useState({
        howWillYouPay: "How will you pay",
        cancel: "Cancel",
        proceed: "Proceed",
        paymentMethod: "Payment Method",
        processing: "Processing",
        walletMessages :{
            enterPin: "Enter Smart Cash PIN",
            walletBlockedMessage: "Your Smart Cash wallet has been blocked due to too many incorrect PIN attempts."
          }
    })
     


    const { data: data, refetch } = useFetch({
        url: ORP_TRANSLATION.replace('languagePrefix', languagePrefix),
        method: GET,
        key: TRANSLATION,
        initialEnabled: false,
        cache: {
            enabled: true,
            ttl: 3600
        }
    });

    useEffect(() => {
        setNoOfAttemptsLeftForPIN(5)
        const cachedData = sessionStorage.getItem(`${TRANSLATION}_${selectedLanguage}`);
        if (!cachedData) {
            refetch(true);
        } else {
            refetch(false)
        }
    }, [selectedLanguage]);

    useEffect(() => {
        if (data?.payment.smartCashPayment) {
            setTranslation(data?.payment.smartCashPayment)
        }
    }, [data])

    useEffect(() => {
        let txnInfo = sessionStorage.getItem("queryData");
        txnInfo = JSON.parse(txnInfo);
        setTxnInfo({ ...txnInfo });
        setEmailId(txnInfo?.emailId);
        let leadInformation = sessionStorage.getItem('airtelWorks');
        if (leadInformation) {
            leadInformation = JSON.parse(leadInformation || {})
            setLeadInfo(leadInformation);
        }
        let configData = sessionStorage.getItem("_c_o_n_f_i_g");
        setConfig(JSON.parse(configData));
    }, [])

    const checkMsisdn = (val, event) => {
        if (val) {
            val = val.replace(/[^0-9]/g, "");
            event.target.value = val;
        }
    };

    const handleChange = (e) => {
        setMobileNumber(e.target.value)
        const { name, value } = e.target;
        if (name == "msisdn") {
            if (value.trim() === "") {
                setMsisdnError("Phone No is required");
            } else {
                setMsisdnError("");
            }
        }
    };
    const cancelTransaction = () => {
        navigate(txnInfo.redirectPage);
    };

    const sendOtp = (event) => {
        event.preventDefault()
        let postRequestData = {
            msisdn: process.env.REACT_APP_OPCO.toLowerCase() == "ga" ? "0" + mobileNumber : mobileNumber,
        };
        let postRequest = {
            data: postRequestData,
        };
        showLoader();
        getOtpV1(postRequest).then(
            (res) => {
                res = res?.data;
                hideLoader();
                if (
                    res &&
                    (res?.statusCode == 200 || res?.status?.toLowerCase() == "success")
                ) {
                    setShowOtpModal(true);
                    setRefId(res?.result?.refId);
                } else {
                    if (res &&
                        (res?.status == 502 || res?.statusCode == 502)) {
                        handleLimitExhaust();
                    }
                    setShowOtpModal(false);
                    showToastMsg("Error", res?.message || "Something Went Wrong!");
                }
            },
            (error) => {
                hideLoader();
                setShowOtpModal(false);
                showToastMsg(
                    "Error",
                    error?.error?.message || error?.message || "Something Went Wrong!"
                );
            }
        );
    };

    const handleLimitExhaust = (message) => {
        setShowOtpModal(false);
        showToastMsg("Error", message || "max limit exhausted, please try after sometime.");
    }

    const handleOtpModalClose = () => {
        setShowOtpModal(false);
    }

    const handleInvalidAmUser = (message) => {
        setMsisdnError(message);
    }

    const handleOtpVerified = (token) => {
        setToken(token)
        setShowIncorrectPinMessage(false)
        setShowPinLockedMessage(false)
        initiateRecharge(pin,token);
        setShowOtpModal(false);
    }
    const handleEncrypedPin = (pin) => {
        setPin(pin)
        processRecharge(transactionId,pin,encryptionKey)
    }
    const handlePinModalClose = () => {
        setShowOtpModal(false);
        setShowPinModal(false);
        setNoOfAttemptsLeftForPIN(5);
    }
    const initiateRecharge = (pin,token) => {
        showLoader();
        let postRequestData = {
            paymentMobile: process.env.REACT_APP_OPCO.toLowerCase() == "ga" ? "0" + mobileNumber : mobileNumber,
            amount: convertedAmount || txnInfo.amount,
            countryCode: process.env.REACT_APP_COUNTRY_CODE || "234",
            currencyCode: selectedCurrencyUnit || process.env.REACT_APP_CURRENCY,
            emailId: "",
            mobileNumber: txnInfo?.msisdn,
            productCode: txnInfo?.productCode || null,
            transactionType: leadInfo?.isAirtelWorks ? "HBB_LEADS" : txnInfo?.transactionType,
            unit: Number(txnInfo?.amount),
            loggedInNumber: (txnInfo?.invoiceDetail && txnInfo?.invoiceDetail?.accountNo) || null,
            accountId: (txnInfo?.invoiceDetail && txnInfo?.invoiceDetail?.accountNo) || null,
            invoiceNumber: (txnInfo?.invoiceDetail && txnInfo?.invoiceDetail?.invoiceNo) || null,
            paymentMode: PAYMENT_MODE_SMARTCASH,
            txnId: leadInfo.id || ""
        };

        const headers = {};
        headers['Authorization'] = `${token?.tokenType} ${token?.accessToken}`
        

        let postRequest = {
            data: postRequestData,
            url: INTIATE_PAYMENT_AM_PIN,
            headers:headers
        };
       
        intiatePayment(postRequest)
            .then((res) => {
                res = res?.data;
                hideLoader();
                if (
                    res &&
                    (res?.statusCode == 200 || res?.status?.toLowerCase() == "success")
                ) {
                    setShowPinModal(true);
                    setEncryptionKey(res?.result?.encryptionKeyDetails.key)
                    setTransactionId(res?.result?.transactionId)
                    eventEmitter('ORP', 'Initiate SmartCash Payment Success', 'click', 'Initiate SmartCash Payment Success', null);
                } else {
                    console.log("error");
                    showToastMsg('Error', res?.message || "Something Went Wrong!")
                    eventEmitter('ORP', 'Initiate SmartCash Payment Failed', 'click', res?.statusCode?.toString() || res?.message, null);
                }
            })
            .catch((error) => {
                hideLoader();
                console.log(error);
                showToastMsg('Error', error?.error?.message || error?.message || "Something Went Wrong!")
            });
    };

    const showToastMsg = (type, message) => {
        setToastMsg({ type, message });
        setTimeout(() => setToastMsg(null), 10000);
    }

    const processRecharge = (txnId,pin,encryptionKey) => {
        if(showPinLockedMessage || noOfAttemptsLeftForPIN == 0 ){
            return;
        }
        let encryptedPin = encryptRSA(pin,encryptionKey)
        let postRequestData = {
            paymentMobile: process.env.REACT_APP_OPCO.toLowerCase() == "ga" ? "0" + mobileNumber : mobileNumber,
            transactionId: txnId,
            isSubscriberRequest: true,
            paymentMode: PAYMENT_MODE_SMARTCASH,
            amPin:encryptedPin,
            proccessFlag: true,
        };
        
        const headers = {};
        headers['Authorization'] = `${token?.tokenType} ${token?.accessToken}`

        let postRequest = {
            data: postRequestData,
            url: PROCESS_TRXN_AM_PIN,
            headers:headers
        };

        showLoader();
        processTrans(postRequest)
            .then((res) => {
                res = res?.data;
                hideLoader();
                if (
                    res &&
                    (res?.statusCode == 200 || res?.status?.toLowerCase() == "success")
                ) {
                    let transactionId = res?.result?.transactionId;
                    setTransactionId(transactionId);
                    transactionId ? callCheckStatus(transactionId) : console.log("Transaction ID not found in the api response", res);
                    eventEmitter('ORP', 'Process SmartCash Payment Success', 'click', 'Process SmartCash Payment Success', null);
                }
                else if (res?.statusCode == '56D005') {
                    if (noOfAttemptsLeftForPIN > 0) {
                        setShowIncorrectPinMessage(true);
                        setNoOfAttemptsLeftForPIN((prev) => prev - 1)
                        initiateRecharge();
                    }
                  }
                  else if (res?.statusCode === 1006) {
                    setShowPinLockedMessage(true);
                    setShowIncorrectPinMessage(false);
                    setNoOfAttemptsLeftForPIN(0)
                  }
                 else {
                    showToastMsg('Error', res?.message || "Something Went Wrong!")
                    eventEmitter('ORP', 'Process SmartCash Payment Failed', 'click', res?.statusCode?.toString() || res?.message, null);
                    setShowPinModal(false)
                }
            })
            .catch((error) => {
                console.log(error);
                hideLoader();
                showToastMsg('Error', error?.error?.message || error?.message || "Something Went Wrong!")
                eventEmitter('ORP', 'Process SmartCash Payment Failed', 'click', error?.error?.toString(), null);
            });
    };

    const callCheckStatus = (txnId) => {
        checkAMstatus(txnId).then(
            (res) => {
                res = res?.data;
                if (
                    res &&
                    (res?.statusCode == 200 || res?.status?.toLowerCase() == "success")
                ) {
                      if (res?.result?.transactionId) {
                        navigateToStatusPage(res?.result?.transactionId);
                       }
                    }
                 else {
                    showToastMsg('Error', res.message || "Something Went Wrong!")
                    eventEmitter('ORP', 'SmartCash Payment Check Status Failed', 'click', res?.message, null);

                }
            },
            (error) => {
                console.log(error);
                showToastMsg('Error', error?.error?.message || error?.message || "Something Went Wrong!")
                eventEmitter('ORP', 'SmartCash Payment Check Status Failed', 'click', error?.error?.toString(), null);

            }
        );
    };
    const navigateToStatusPage = (txnId) => {
        if (txnId) {
            navigate("/payment/status?id=" + txnId);
            return;
        }
    };
    return (
        <>
            <div className="card-pay-container ">
                <h3>{translation?.howWillYouPay}</h3>
                <div className="smartcash-pay">
                    <div className="payment-method">
                        <h5 >{translation?.paymentMethod}</h5>
                        <img
                            src="assets/icons/smartcash-logo.png"
                            width="200px" className="smartcash-logo"
                        />
                    </div>
                    <form autoComplete="off">
                        <div className="card-pay-footer airtime_payment_form">
                            <div className="card-pay-form">
                                <span className="country_code">
                                    +{process.env.REACT_APP_COUNTRY_CODE}
                                </span>
                                <input
                                    type="text"
                                    name="msisdn"
                                    placeholder="Registered Mobile Number"
                                    value={mobileNumber}
                                    onChange={handleChange}
                                    onInput={(event) => checkMsisdn(event.target.value, event)}
                                    maxLength={process.env.REACT_APP_NUMBER_MAX_LENGTH}
                                />
                                {msisdnError && <p className="error">{msisdnError}</p>}
                            </div>
                        </div>
                        <div className="card-pay-payment-button">
                            <button
                                className="continue-btn"
                                disabled={msisdnError || mobileNumber.length != process.env.REACT_APP_NUMBER_MAX_LENGTH}
                                onClick={(event) => sendOtp(event)}
                            >
                                {translation?.proceed}
                            </button>
                            <button onClick={cancelTransaction} className="cancel-btn" >
                                {translation?.cancel}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
            {toastMsg && <ToastMsg message={toastMsg.message} type={toastMsg.type} onClose={() => setToastMsg(null)}></ToastMsg>}
            {showOtpModal && <AwOtpModal
                toggleModalEvent={handleOtpModalClose}
                enablePin={enablePin}
                inValidAmUserEvent={handleInvalidAmUser}
                refId={refId}
                msisdn={mobileNumber}
                sendOtpVerifiedEvent={handleOtpVerified}
                maxLimitExaustEvent={handleLimitExhaust}
                isAirtelNumber={isAirtelNumber}
                // email={email}
                paymentMode={PAYMENT_MODE_SMARTCASH}
            />}
            {showPinModal && <PinComponent
                amount={txnInfo?.amount}
                sendEncryptedPin={handleEncrypedPin}
                showIncorrectPinMessage={showIncorrectPinMessage}
                showPinLockedMessage={showPinLockedMessage}
                noOfAttemptsLeftForPIN={noOfAttemptsLeftForPIN}
                customerCareNumber={config?.customerCareNumber}
                dial={config?.pinResetDial}
                toggleModalEvent={handlePinModalClose}
                walletMessages={translation.walletMessages}
            />}
        </>
    );
}